// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getAccountState } from "@insite/client-framework/Store/Data/Accounts/AccountsSelector";
import { chain, DispatchSetInitialValues } from "@insite/client-framework/Store/Pages/UserSetup/Handlers/DisplayUser";
import setUserFields from "@insite/client-framework/Store/Pages/UserSetup/Handlers/SetUserFields";

type HandlerType = Parameters<typeof DispatchSetInitialValues>[0];

export const CustomDispatchSetInitialValues = (props: HandlerType) => {
    const user = getAccountState(props.getState(), props.parameter.userId).value;
    if (!user) {
        throw new Error("There was no user and we were trying to set initial values for the user setup page.");
    }

    props.dispatch({
        type: "Pages/UserSetup/SetInitialValues",
        user,
    });

    props.dispatch(setUserFields({ ...user, roleOrDepartment: user.properties?.roleOrDepartment } as any));
};

replaceInChain(chain, DispatchSetInitialValues, CustomDispatchSetInitialValues);
